import { h } from '@stencil/core';
import { send, filtersVirtualPageEvent } from '@pes-ui/utils';
export class PesResponsiveFilter {
  constructor() {
    this.facetContentMaxHeight = 32 * 10 + 9 * 4 + 2 * 16;
    this.showFilterMobileView = () => {
      this.showMobileFilter.emit();
      send(filtersVirtualPageEvent);
    };
    this.filtrationSmartData = undefined;
    this.resetButtonLabel = undefined;
    this.viewMoreFacetsLabel = undefined;
    this.viewLessFacetsLabel = undefined;
    this.visibleFacetsCount = 5;
    this.visibleRefinementsPerFacetCount = 5;
    this.headerLabelDesktop = undefined;
    this.headerLabelMobile = undefined;
    this.viewProductsLabel = undefined;
    this.viewMoreRefinementsLabel = undefined;
    this.viewLessRefinementsLabel = undefined;
    this.noProductsFoundLabel = undefined;
    this.isMobileViewVisible = undefined;
    this.isMobileCategorySelected = undefined;
    this.productsCount = undefined;
    this.selectedSectionsCount = undefined;
    this.categories = [];
  }
  get showProductsLabel() {
    const label = this.productsCount > 0 ? this.viewProductsLabel : this.noProductsFoundLabel;
    return `${label} (${this.productsCount})`;
  }
  renderMobileFilters() {
    return (h("div", { class: "responsive-filters__mobile" }, this.isMobileCategorySelected && (h("se-filtration-smart-mobile-view-trigger", { label: this.headerLabelMobile, count: this.selectedSectionsCount, onClick: this.showFilterMobileView })), !this.isMobileCategorySelected && (h("pes-mobile-filters-categories", { categories: this.categories }))));
  }
  renderDesktopFilters() {
    return (h("div", { class: {
        'responsive-filters__desktop': true,
        'responsive-filters__desktop--visible': this.isMobileViewVisible,
      } }, h("se-filtration-smart", { filters: this.filtrationSmartData, resetButtonLabel: this.resetButtonLabel, viewMoreFacetsLabel: this.viewMoreFacetsLabel, viewLessFacetsLabel: this.viewLessFacetsLabel, visibleFacetsCount: this.visibleFacetsCount, visibleRefinementsPerFacetCount: this.visibleRefinementsPerFacetCount, headerLabelDesktop: this.headerLabelDesktop, headerLabelMobile: this.headerLabelMobile, isMobileViewVisible: this.isMobileViewVisible, showProductsLabel: this.showProductsLabel, maxFacetContentHeight: this.facetContentMaxHeight, viewMoreRefinementsLabel: this.viewMoreRefinementsLabel, viewLessRefinementsLabel: this.viewLessRefinementsLabel })));
  }
  render() {
    return (h("div", { class: "responsive-filters" }, this.renderMobileFilters(), this.renderDesktopFilters()));
  }
  static get is() { return "pes-responsive-filters"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["responsive-filters.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["responsive-filters.css"]
    };
  }
  static get properties() {
    return {
      "filtrationSmartData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "FiltrationSmartData",
          "resolved": "FiltrationSmartData",
          "references": {
            "FiltrationSmartData": {
              "location": "import",
              "path": "@se/web-ui/types/components/filtration-smart/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "resetButtonLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "reset-button-label",
        "reflect": false
      },
      "viewMoreFacetsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-more-facets-label",
        "reflect": false
      },
      "viewLessFacetsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-less-facets-label",
        "reflect": false
      },
      "visibleFacetsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "visible-facets-count",
        "reflect": false,
        "defaultValue": "5"
      },
      "visibleRefinementsPerFacetCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "visible-refinements-per-facet-count",
        "reflect": false,
        "defaultValue": "5"
      },
      "headerLabelDesktop": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "header-label-desktop",
        "reflect": false
      },
      "headerLabelMobile": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "header-label-mobile",
        "reflect": false
      },
      "viewProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-products-label",
        "reflect": false
      },
      "viewMoreRefinementsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-more-refinements-label",
        "reflect": false
      },
      "viewLessRefinementsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-less-refinements-label",
        "reflect": false
      },
      "noProductsFoundLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-products-found-label",
        "reflect": false
      },
      "isMobileViewVisible": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile-view-visible",
        "reflect": false
      },
      "isMobileCategorySelected": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile-category-selected",
        "reflect": false
      },
      "productsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-count",
        "reflect": false
      },
      "selectedSectionsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-sections-count",
        "reflect": false
      },
      "categories": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TFiltersCategory[]",
          "resolved": "TFiltersCategory[]",
          "references": {
            "TFiltersCategory": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      }
    };
  }
  static get events() {
    return [{
        "method": "showMobileFilter",
        "name": "showMobileFilter",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "void",
          "resolved": "void",
          "references": {}
        }
      }];
  }
}
